import ContainerLayout from '@/components/Layout/ContainerLayout'
import HeaderLayout from '@/components/Layout/HeaderLayout'
import { Paper } from '@/components/Paper'
import { useRef, useState } from 'react'
import Header from '../components/Header'
import TabelaTransportadora from './Components/TabelaModeloTransportadora'



function ModeloTransportadora() {
    const [isFilterVisible, setIsFilterVisible] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const headers = [
      { label: 'Selecionar', key: 'checkbox', isVisible: true },
      { label: 'Tipo', key: 'tipo', isVisible: true },
      { label: 'Box', key: 'box', isVisible: true },
      { label: 'CPF', key: 'cpf', isVisible: true },
      { label: 'Endereço', key: 'endereco', isVisible: true },
      { label: 'Bairro', key: 'bairro', isVisible: true },
      { label: 'Transportadora', key: 'transportadora', isVisible: true },
      { label: 'Celular', key: 'celular', isVisible: true },
      { label: 'Ativo', key: 'ativo', isVisible: true },
    ];
    
    const mockPermissions = [
      {
        id: 1,
        tipo: 'Carregamento',
        box: 'BOX 1',
        cpf: '64818586315',
        endereco: 'AVENIDA TRAJANO HONORATO',
        bairro: 'LAGOA DO MATO',
        transportadora: 'SILVANO GALINDO DA SILVA',
        celular: '85981547120',
        ativo: true,
      },
      {
        id: 2,
        tipo: 'Agendamento',
        box: 'BOX 2',
        cpf: '64818586315',
        endereco: 'RUA SENADOR ROBERT KENNEDY 209',
        bairro: 'BARRA DO CEARA',
        transportadora: 'ANTONIO BERNARDO CAVALCANTE',
        celular: '88991547122',
        ativo: false,
      },
      {
        id: 3,
        tipo: 'Ambos',
        box: 'BOX 3',
        cpf: '64818586315',
        endereco: 'RUA VERDOZA MAIA',
        bairro: 'JARDIM JATOBA',
        transportadora: 'JOSE MATHEUS DA SILVA OLIVEIRA',
        celular: '71981541131',
        ativo: true,
      },
    ];

    const [visibleHeaders, setVisibleHeaders] = useState(headers);

    const handleDelete = (selectedData: any[]) => {
    };

    const printRef = useRef(null); 
  return (
    <>
      <ContainerLayout>
        <HeaderLayout title="Portaria" calendarInput />
        <Paper m={6} bg="white" py={4} px={2} rounded="xl" shadow="sm" border="1px solid rgba(200, 200, 200, .4)">
          <Header
            onHeadersChange={setVisibleHeaders}
            isFilterVisible={isFilterVisible}
            headers={headers}
            isMenuEnabled
            onToggleFilter={() => setIsFilterVisible((prev) => !prev)}
            onView={() => console.log("Visualizar ação executada")}
            printRef={printRef} 
            title={'Transportadora'}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
          />
        
        
          <div id="print-content" ref={printRef}>
              <TabelaTransportadora headers={visibleHeaders}  onDelete={handleDelete} dados={mockPermissions} valoPesquisa={searchTerm}  />
          </div>
        </Paper>
      </ContainerLayout>
    </>
  )
}

export default ModeloTransportadora